import React from "react";
import { CircleDollarSign } from "lucide-react";
import PageHeader from "../../../components/common/PageHeader";
import { useAuth } from "../../../app/providers/AuthProvider";
import ScopedPricingEditor from "../shared/ScopedPricingEditor";

function getCurrentUserId(user) {
  return (
    user?.id ||
    user?.userId ||
    user?.Id ||
    user?.UserId ||
    null
  );
}

export default function ResellerPricingPage() {
  const { user, userName } = useAuth();
  const actorUserId = getCurrentUserId(user);
  const scopeLabel = userName ? `${userName} Reseller Pricing` : "My Reseller Pricing";

  return (
    <div className="min-h-screen bg-[#f3f4f6] py-6">
      <section className="px-4">
        <div className="mx-auto max-w-[1240px] space-y-6">
          <div className="px-4 pt-4 pb-1">
            <PageHeader
              icon={CircleDollarSign}
              title="Reseller Pricing Rules"
              subtitle="Configure your reseller-level pricing rules from the base price you inherit upstream."
            />
          </div>

          <div className="px-4">
            <ScopedPricingEditor
              scopeLevel="Reseller"
              scopeEntityId={actorUserId}
              scopeLabel={scopeLabel}
              description="Adjust your inherited base price to define the default pricing you want to apply to businesses managed under your reseller scope."
              readMode="actor"
              displayVariant="base"
              emptyStateTitle="Reseller account context is not available."
              emptyStateBody="Refresh the session and try again after your reseller account context finishes loading."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
